import React from "react";
import { InfoIcon } from "../../../../svg/info-icon";

type BadgeCellValue =
  | {
      text: string;
      color?: string;
      bgColor?: string;
      displayText?: string;
      showInfoIcon?: boolean;
      hoverText?: string;
    }
  | null
  | undefined
  | "";

interface BadgeCellProps {
  value: BadgeCellValue;
  [key: string]: unknown;
}

/**
 * Renders a colored badge (and optional info icon) for table cells.
 * When `showInfoIcon` is false, the native tooltip uses `hoverText` or `displayText`
 * on the full-width wrapper so hovering the cell area still shows the title.
 *
 * @param value - Badge label, colors, and optional tooltip fields
 * @returns Badge markup for the standard badge table cell type
 */
export const BadgeCell: React.FC<BadgeCellProps> = ({ value }) => {
  if (value == null || value === "") {
    return <div className="flex h-full w-full flex-row items-center gap-1" />;
  }

  const badge = value;
  const nonInfoTooltip = !badge.showInfoIcon
    ? badge.hoverText || badge.displayText
    : undefined;

  return (
    <div
      className="flex w-full flex-row items-center gap-1"
      title={nonInfoTooltip}
    >
      <div
        className="table-cell-badge"
        style={{
          color: badge.color || "#000000",
          backgroundColor: badge.bgColor || "#F5F5F5",
        }}
        title={badge.showInfoIcon ? badge.displayText : undefined}
      >
        {badge.text}
      </div>
      {badge.showInfoIcon && (
        <div title={badge.hoverText} className="cursor-pointer">
          <InfoIcon />
        </div>
      )}
    </div>
  );
};

export default BadgeCell;
